import { Quill } from "react-quill-new";

const BlockEmbed = Quill.import("blots/block/embed") as any;

export class ImagePlaceholderBlot extends BlockEmbed {
  static blotName = "image-placeholder";
  static tagName = "div";
  static className = "ql-image-placeholder";

  static create(value: { width?: number; height?: number }) {
    const node = super.create();

    node.setAttribute("contenteditable", "false");
    node.style.width = `${value?.width ?? 150}px`;
    node.style.height = `${value?.height ?? 100}px`;

    return node;
  }
}
